// @flow
import { Cookies } from "react-cookie";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import { fetchJSON } from "../../helpers/api";
import { ApiCall } from "../../services/index";
import { endpoints } from "../../services/endpoints";
import { toast, ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  GRAPH_LIST,

} from "./constants";

import {
  getGraphListSuccess,
  getGraphListFailed,

} from "./actions";

import { getLoggedInUser } from "../../helpers/authUtils";

const mytaskAddedSucsess = () =>
  toast.success("Mytask Added Successfully", { transition: Zoom });
const mytaskCommentAddedSucsess = () =>
  toast.success("Comment Added Successfully", { transition: Zoom });
const mytaskDeletedSuccess = () =>
  toast.success("Mytask Deleted Successfully", { transition: Zoom });
const mytaskUpdated = () =>
  toast.info("Mytask Updated Successfully", { transition: Zoom });
const emptyAllFields = () =>
  toast.warning("Please fill all fields", { transition: Zoom });
const WarnFields = (msg) => toast.error(msg, { transition: Zoom });
/**
 * Login the user
 * @param {*} payload - username and password
 */
function* GraphList({ payload: data }) {
  const user = getLoggedInUser();
  let options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.token,
    },
    method: "POST",
    url: endpoints.workGraph,
    data: data,
  };

  try {
    const response = yield call(ApiCall, options);

    yield put(getGraphListSuccess(response.data));
  } catch (error) {
    let message;
    switch (error.response.status) {
      case 500:
        message = "Internal Server Error";
        WarnFields(message);
        break;
      case 401:
        message = "Invalid credentials";
        WarnFields(message);
        break;
      case 400:
        message = error.response.data && error.response.data.error;
        WarnFields(message);
        break;
      default:
        message = error;
    }
    yield put(getGraphListFailed(message));
  }
}


export function* watchGraphListt(): any {
  yield takeEvery(GRAPH_LIST, GraphList);
}


function* authSaga(): any {
  yield all([
    fork(watchGraphListt),
 

  ]);
}

export default authSaga;
